import { useEffect, useMemo } from "react";
import { PAGE_TEMPLATE_OPTIONS } from "../../Registry/index.js";

function slugifyPagePath(value = "") {
  return value
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

function Step1Template({
  templateId,
  setTemplateId,
  name,
  setName,
  path,
  setPath,
  pathTouched,
  setPathTouched,
  isHomepage = false,
  pageType = "page",
  templateAccess = [],
  orgSlug = ""
}) {
  useEffect(() => {
    if (isHomepage) return;
    if (pathTouched) return;
    setPath(slugifyPagePath(name || ""));
  }, [name, isHomepage, pathTouched, setPath]);

  const allowedTemplateIds = useMemo(() => {
    return templateAccess.map((item) => item.template_id);
  }, [templateAccess]);

  const currentPageType = isHomepage ? "home" : "page";

  const filteredTemplates = useMemo(() => {
    return PAGE_TEMPLATE_OPTIONS.filter((t) => {
      if (t.pageType !== currentPageType) return false;

      if (t.id === "default-homepage" || t.id === "default-contact") {
        return true;
      }

      return allowedTemplateIds.includes(t.id);
    });
  }, [currentPageType, allowedTemplateIds]);

  useEffect(() => {
    if (!filteredTemplates.some((t) => t.id === templateId)) {
      if (filteredTemplates.length > 0) {
        setTemplateId(filteredTemplates[0].id);
      }
    }
  }, [filteredTemplates, templateId, setTemplateId]);

  return (
    <div className="card">
      <h2>{isHomepage ? "Choose your homepage template" : "Choose your template"}</h2>

      <div className="templates">
        {filteredTemplates.map((t) => (
          <button
            key={t.id}
            type="button"
            className={`tpl ${templateId === t.id ? "active" : ""}`}
            onClick={() => setTemplateId(t.id)}
          >
            <div className="tpl-name">{t.name}</div>
            <div className="tpl-desc">{t.desc}</div>
          </button>
        ))}
      </div>

      {!isHomepage && (
        <>
          <label className="field">
            <span>Page name</span>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Contact"
            />
          </label>

          <label className="field">
            <span>Page path</span>
            <input
              type="text"
              value={path}
              onChange={(e) => {
                setPathTouched(true);
                setPath(e.target.value);
              }}
              placeholder="contact"
            />
            <div className="field-help">
              {orgSlug ? `sportinghip.com/${orgSlug}/${path || "your-page"}` : `/${path || "your-page"}`}
            </div>
          </label>
        </>
      )}
    </div>
  );
}

export default Step1Template;